__turbopack_context__.v({
  "appliedButton": "uu6jFW_appliedButton",
  "applyAction": "uu6jFW_applyAction",
  "applyLink": "uu6jFW_applyLink",
  "body": "uu6jFW_body",
  "emptyBody": "uu6jFW_emptyBody",
  "emptyLead": "uu6jFW_emptyLead",
  "masthead": "uu6jFW_masthead",
  "meta": "uu6jFW_meta",
  "postingLink": "uu6jFW_postingLink",
  "stampRow": "uu6jFW_stampRow",
  "stampTone": "uu6jFW_stampTone",
  "teamAvatar": "uu6jFW_teamAvatar",
  "teamInitials": "uu6jFW_teamInitials",
  "teamMain": "uu6jFW_teamMain",
  "teamName": "uu6jFW_teamName",
  "teamRow": "uu6jFW_teamRow",
  "title": "uu6jFW_title",
});
